import React from "react";
import { InlineMath } from "react-katex";
import { makeSimpleClosedTask, normalizeMay2026Variant, pick } from "../../../../matura/MaturaMay2026ClosedTaskSupport";

export function generateTask(options = {}) {
  const variant = normalizeMay2026Variant(options);
  const k = variant === "original" ? 2 : pick([2,3,4,5,6,7,8,9]);
  const answer = k * k === 4 ? "\\frac43" : `\\frac{${k*k}}3`;
  return makeSimpleClosedTask({
    type: "MaturaConeCylinderVolumeRatioClosedTask",
    taskNumber: "28",
    variant,
    prompt: <>Stożek i walec mają równe wysokości, a promień stożka jest <InlineMath math={String(k)} /> razy większy od promienia walca. Stosunek objętości stożka do objętości walca wynosi:</>,
    correct: answer,
    wrong: [`\\frac1{${3*k*k}}`, `\\frac{${k}}{3}`, String(k*k)],
    tags: ["stereometria", "objetosc"],
    explanationSteps: [{ title: "Zapisujemy oba wzory przy wspólnej wysokości i promieniu walca.", latex: `\\frac{V_s}{V_w}=\\frac{\\frac13\\pi(${k}r)^2H}{\\pi r^2H}=${answer}` }],
  });
}

export { checkClosedAnswer as checkAnswer, renderClosedAnswer as renderAnswer, renderClosedExplanation as renderExplanation, renderClosedInput as renderInput, renderClosedTask as renderTask, renderClosedUserAnswer as renderUserAnswer } from "../../../../matura/MaturaMay2026ClosedTaskSupport";
